import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { __awaiter } from 'tslib';
import * as i1$1 from '@angular/forms';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import * as i3 from 'ngx-toastr';
import * as i4 from 'app-services-library';
import * as i5 from 'reference-library';
import * as i6 from 'primeng/inputswitch';
import * as i7 from '@angular/common';
import * as i8 from 'primeng/dropdown';
import { PrimengLibraryModule } from 'primeng-library';

class SubTaskInterpreterDetailsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getLanguages() {
        return this.httpClient.get(`/referenceLibrary/LANGUAGE`).pipe(map((response) => {
            return response.data;
        }));
    }
    filteredInterpreterList(companyId = 0, userId = 0) {
        return this.httpClient.get(`/petitioninterpreter/${companyId}/${userId}`).pipe(map((response) => {
            return response.data;
        }));
    }
    interpreterList(langId, employeeId) {
        return this.httpClient.get(`/petitioninterpreter/interpreternames/${langId}/${employeeId}`).pipe(map((response) => {
            return response.data;
        }));
    }
}
SubTaskInterpreterDetailsService.ɵfac = function SubTaskInterpreterDetailsService_Factory(t) { return new (t || SubTaskInterpreterDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
SubTaskInterpreterDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: SubTaskInterpreterDetailsService, factory: SubTaskInterpreterDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubTaskInterpreterDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function SubTaskInterpreterDetailsComponent_div_8_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1, "Please select language.");
    i0.ɵɵelementEnd();
} }
function SubTaskInterpreterDetailsComponent_div_8_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1, "Please select interpreter.");
    i0.ɵɵelementEnd();
} }
function SubTaskInterpreterDetailsComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵelementStart(2, "label", 10);
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4, "Interpreting Language");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p-dropdown", 11);
    i0.ɵɵlistener("onChange", function SubTaskInterpreterDetailsComponent_div_8_Template_p_dropdown_onChange_5_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.onLanguageChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SubTaskInterpreterDetailsComponent_div_8_span_6_Template, 2, 0, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 9);
    i0.ɵɵelementStart(8, "label", 13);
    i0.ɵɵelementStart(9, "span", 4);
    i0.ɵɵtext(10, "Interpreter Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "p-dropdown", 14);
    i0.ɵɵlistener("onChange", function SubTaskInterpreterDetailsComponent_div_8_Template_p_dropdown_onChange_11_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.onInterpreterChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SubTaskInterpreterDetailsComponent_div_8_span_12_Template, 2, 0, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("options", ctx_r0.languagesList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.interpreterDetailsForm.get("interpreterLangId").touched && ctx_r0.interpreterDetailsForm.get("interpreterLangId").invalid);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("options", ctx_r0.interpreterList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.interpreterDetailsForm.get("interpreterId").touched && ctx_r0.interpreterDetailsForm.get("interpreterId").invalid);
} }
const _c0 = function () { return { standalone: true }; };
class SubTaskInterpreterDetailsComponent {
    constructor(fb, apiService, parentFor, toast, appServicesLibraryService, referenceLibraryService) {
        this.fb = fb;
        this.apiService = apiService;
        this.parentFor = parentFor;
        this.toast = toast;
        this.appServicesLibraryService = appServicesLibraryService;
        this.referenceLibraryService = referenceLibraryService;
        this.languagesList = [];
        this.interpreterName = [];
        this.isIncludeInterpreter = false;
        this.interpreterList = [];
        this.matchedInterpreterList = [];
        this.selectedlanguage = '';
        this.subTaskDetails = null;
        this.destroy$ = new Subject();
        this.companyId = parseInt(sessionStorage.getItem('companyId'));
        this.userId = parseInt(sessionStorage.getItem('userId'));
    }
    ngOnInit() {
        this.getLanguages();
        this.interpreterDetailsForm = this.fb.group({
            isInterpreterReqd: new FormControl('No'),
            interpreterLangId: new FormControl(''),
            interpreterId: new FormControl(''),
            interpreterLanguageId: new FormControl(''),
        });
        this.form = this.parentFor.form;
        this.form.addControl('isInterpreterReqd', new FormControl('No'));
        this.form.addControl('interpreterLangId', new FormControl(''));
        this.form.addControl('interpreterId', new FormControl(''));
        this.form.addControl('interpreterLanguageId', new FormControl(''));
        if (this.subTaskDetails && this.subTaskDetails.isInterpreterReqd) {
            this.isIncludeInterpreter = this.subTaskDetails.isInterpreterReqd === 'YES' ? true : false;
            this.includeInterpreter();
            if (this.isIncludeInterpreter) {
                const patchvalue = {
                    isInterpreterReqd: 'Yes'
                };
                this.form.patchValue(patchvalue);
                this.interpreterDetailsForm.patchValue(patchvalue);
            }
        }
    }
    // loadfilteredInterpreterList() {
    //   this.apiService.filteredInterpreterList(this.companyId,this.userId).subscribe((response) => {
    //     this.interpreterList = response.map(ele=>{
    //       ele.name = ele.firstName+' '+ele.middleName+' '+ele.lastName;
    //       return ele;
    //     });
    //   });
    // } 
    getLanguages() {
        this.apiService.getLanguages().pipe(takeUntil(this.destroy$)).subscribe((response) => {
            if (response && response.length > 0) {
                const languagesList = response.filter(lang => { if (lang.name !== 'English') {
                    return lang;
                } });
                this.referenceLibraryService.translateArray(languagesList, 'name')
                    .then(translated => {
                    this.languagesList = translated;
                })
                    .catch(error => console.error("Translation error:", error));
                if (this.subTaskDetails && this.subTaskDetails.interpreterLanguage) {
                    const savedLanguage = this.languagesList.find((lang) => lang.name === this.subTaskDetails.interpreterLanguage);
                    if (savedLanguage) {
                        this.form.patchValue({ interpreterLangId: this.subTaskDetails.interpreterLangId });
                        this.interpreterDetailsForm.patchValue({ interpreterLanguageId: this.subTaskDetails.interpreterLangId });
                        this.onLanguageChange({ value: savedLanguage.id });
                    }
                }
            }
        });
    }
    includeInterpreter() {
        if (this.isIncludeInterpreter) {
            this.form.controls['isInterpreterReqd'].setValue('Yes');
            this.form.controls['interpreterLangId'].setValue('');
            this.form.controls['interpreterLangId'].setValidators([Validators.required]);
            this.form.controls['interpreterLangId'].updateValueAndValidity();
            this.form.controls['interpreterId'].setValue('');
            this.form.controls['interpreterId'].setValidators([Validators.required]);
            this.form.controls['interpreterId'].updateValueAndValidity();
            this.form.controls['interpreterLanguageId'].setValue('');
            this.form.controls['interpreterLanguageId'].setValidators([Validators.required]);
            this.form.controls['interpreterLanguageId'].updateValueAndValidity();
            this.interpreterDetailsForm.controls['isInterpreterReqd'].setValue('Yes');
            this.interpreterDetailsForm.controls['interpreterLangId'].setValidators([Validators.required]);
            this.interpreterDetailsForm.controls['interpreterLangId'].updateValueAndValidity();
            this.interpreterDetailsForm.controls['interpreterId'].setValidators([Validators.required]);
            this.interpreterDetailsForm.controls['interpreterId'].updateValueAndValidity();
            this.interpreterDetailsForm.controls['interpreterLanguageId'].setValidators([Validators.required]);
            this.interpreterDetailsForm.controls['interpreterLanguageId'].updateValueAndValidity();
        }
        else {
            this.form.controls['isInterpreterReqd'].setValue('No');
            this.form.controls['interpreterLangId'].setValue('');
            this.form.controls['interpreterId'].setValue('');
            this.form.controls['interpreterLangId'].clearValidators();
            this.form.controls['interpreterLangId'].updateValueAndValidity();
            this.form.controls['interpreterId'].clearValidators();
            this.form.controls['interpreterId'].updateValueAndValidity();
            this.form.controls['interpreterLanguageId'].clearValidators();
            this.form.controls['interpreterLanguageId'].updateValueAndValidity();
            this.interpreterDetailsForm.controls['isInterpreterReqd'].setValue('No');
            this.interpreterDetailsForm.controls['interpreterLangId'].setValue('');
            this.interpreterDetailsForm.controls['interpreterId'].setValue('');
            this.interpreterDetailsForm.controls['interpreterLangId'].clearValidators();
            this.interpreterDetailsForm.controls['interpreterLangId'].updateValueAndValidity();
            this.interpreterDetailsForm.controls['interpreterId'].clearValidators();
            this.interpreterDetailsForm.controls['interpreterId'].updateValueAndValidity();
            this.interpreterDetailsForm.controls['interpreterLanguageId'].clearValidators();
            this.interpreterDetailsForm.controls['interpreterLanguageId'].updateValueAndValidity();
        }
    }
    onLanguageChange(event) {
        this.getInterpreterList(event.value);
        this.form.controls['interpreterLangId'].setValue(event.value);
        this.interpreterDetailsForm.controls['interpreterLangId'].setValue(event.value);
        this.languagesList.forEach(eve => {
            if (eve.id == event.value) {
                this.selectedlanguage = eve.name;
            }
        });
    }
    getInterpreterList(langId) {
        let employeeId = parseInt(sessionStorage.getItem("setPreparerAttorneyId")) ? sessionStorage.getItem("setPreparerAttorneyId") : (this.form.value.preparerAttorneyId ? this.form.value.preparerAttorneyId : (this.subTaskDetails && this.subTaskDetails.preparerAttorneyId ? this.subTaskDetails.preparerAttorneyId : null));
        if (!employeeId || employeeId == 'undefined') {
            this.toast.warning('Lawfirm and Preparer Name not selected.', 'Warning');
            return;
        }
        this.interpreterList = [];
        this.form.controls['interpreterLanguageId'].setValue('');
        this.interpreterDetailsForm.controls['interpreterLanguageId'].setValue('');
        this.form.controls['interpreterId'].setValue('');
        this.interpreterDetailsForm.controls['interpreterId'].setValue('');
        this.apiService.interpreterList(langId, employeeId).subscribe((response) => {
            const interpreterList = response.map(ele => {
                ele.name = ele.firstName + ' ' + ele.middleName + ' ' + ele.lastName;
                return ele;
            });
            this.referenceLibraryService.translateArray(interpreterList, 'name')
                .then(translated => {
                this.interpreterList = translated;
            })
                .catch(error => console.error("Translation error:", error));
            if (this.interpreterList.length == 0) {
                this.toast.warning('Interpreter not found for selected Lawfirm and Preparer Name.', 'Warning');
            }
            else {
                if (this.subTaskDetails && this.subTaskDetails.interpreterName) {
                    const savedInterprater = this.interpreterList.find((intprtr) => intprtr.name === this.subTaskDetails.interpreterName);
                    if (savedInterprater) {
                        this.form.patchValue({ interpreterId: savedInterprater.id });
                        this.interpreterDetailsForm.patchValue({ interpreterId: savedInterprater.id });
                        this.onInterpreterChange({ value: savedInterprater.id });
                    }
                }
            }
        });
    }
    onInterpreterChange(event) {
        let interpreter = [];
        function getInterpreterLanguageId(arr, lang) {
            return __awaiter(this, void 0, void 0, function* () {
                let interpreterLanguageId = '';
                arr.languages.forEach((element, i) => {
                    if (element == lang) {
                        interpreterLanguageId = arr.languagesIds[i];
                    }
                });
                return interpreterLanguageId;
            });
        }
        this.interpreterList.forEach((ele) => __awaiter(this, void 0, void 0, function* () {
            if (ele.id == event.value) {
                yield interpreter.push(event.name);
                let lang = yield getInterpreterLanguageId(ele, this.selectedlanguage);
                this.interpreterDetailsForm.controls['interpreterId'].setValue(ele.id);
                this.form.controls['interpreterId'].setValue(ele.id);
                this.interpreterDetailsForm.controls['interpreterLanguageId'].setValue(lang);
                this.form.controls['interpreterLanguageId'].setValue(lang);
            }
        }));
    }
    ngAfterViewInit() {
        this.translet();
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
SubTaskInterpreterDetailsComponent.ɵfac = function SubTaskInterpreterDetailsComponent_Factory(t) { return new (t || SubTaskInterpreterDetailsComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(SubTaskInterpreterDetailsService), i0.ɵɵdirectiveInject(i1$1.FormGroupDirective), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.AppServicesLibraryService), i0.ɵɵdirectiveInject(i5.ReferenceLibraryService)); };
SubTaskInterpreterDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SubTaskInterpreterDetailsComponent, selectors: [["lib-sub-task-interpreter-details"]], inputs: { subTaskDetails: "subTaskDetails" }, decls: 9, vars: 5, consts: [[3, "formGroup"], [1, "p-grid", "dashed-line", "p-my-4"], [1, "p-grid", "p-my-2", "ml-4", "pl-3"], ["name", "question", 1, "p-col-4"], [1, "common-bene-class-for-translation"], ["id", "element_interpreter", 1, "p-col-1"], [3, "ngModel", "ngModelOptions", "ngModelChange", "onChange"], ["class", "p-fluid p-formgrid p-grid ml-4 pl-3", 4, "ngIf"], [1, "p-fluid", "p-formgrid", "p-grid", "ml-4", "pl-3"], [1, "p-col-4"], ["for", "_languagesList", 1, "create-task-label", "mb-0", "required"], ["inputId", "_languagesList", "formControlName", "interpreterLangId", "placeholder", "Select language", "optionLabel", "name", "optionValue", "id", "appendTo", "body", 3, "options", "onChange"], ["class", "invalid-message", 4, "ngIf"], ["for", "_interpreterName", 1, "create-task-label", "mb-0", "required"], ["inputId", "_interpreterName", "formControlName", "interpreterId", "placeholder", "Select interpreter", "optionLabel", "name", "optionValue", "id", "appendTo", "body", 3, "options", "onChange"], [1, "invalid-message"]], template: function SubTaskInterpreterDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵtext(5, " Do you want to include interpreter? ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p-inputSwitch", 6);
        i0.ɵɵlistener("ngModelChange", function SubTaskInterpreterDetailsComponent_Template_p_inputSwitch_ngModelChange_7_listener($event) { return ctx.isIncludeInterpreter = $event; })("onChange", function SubTaskInterpreterDetailsComponent_Template_p_inputSwitch_onChange_7_listener() { return ctx.includeInterpreter(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, SubTaskInterpreterDetailsComponent_div_8_Template, 13, 4, "div", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.interpreterDetailsForm);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngModel", ctx.isIncludeInterpreter)("ngModelOptions", i0.ɵɵpureFunction0(4, _c0));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isIncludeInterpreter);
    } }, directives: [i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i6.InputSwitch, i1$1.NgControlStatus, i1$1.NgModel, i7.NgIf, i8.Dropdown, i1$1.FormControlName], styles: ["[_nghost-%COMP%]   .mat-slide-toggle.mat-checked[_ngcontent-%COMP%]    .mat-slide-toggle-bar:after{content:\"Yes\";font-size:50%;font-weight:700;color:#fff;position:absolute;left:4px;top:-5px}[_nghost-%COMP%]   .mat-slide-toggle[_ngcontent-%COMP%]:not(.mat-checked)    .mat-slide-toggle-bar:after{content:\"No\";font-size:50%;font-weight:700;color:#fff;position:absolute;left:21px;top:-5px}[_nghost-%COMP%]   .mat-slide-toggle[_ngcontent-%COMP%]   .mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#30b1e1!important}  .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar,   .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb{background-color:#30b1e1}.create-task-label[_ngcontent-%COMP%]{font-size:14px!important}input[readonly][_ngcontent-%COMP%]{background-color:#f1f1f1!important;border:1px solid #c3d0de!important;box-shadow:none!important;height:40px!important}.extra-ordinary-dropdown[_ngcontent-%COMP%]{display:grid}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubTaskInterpreterDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-sub-task-interpreter-details',
                templateUrl: 'sub-task-interpreter-details.component.html',
                styleUrls: ['./sub-task-interpreter-details.component.scss'],
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: SubTaskInterpreterDetailsService }, { type: i1$1.FormGroupDirective }, { type: i3.ToastrService }, { type: i4.AppServicesLibraryService }, { type: i5.ReferenceLibraryService }]; }, { subTaskDetails: [{
            type: Input
        }] }); })();

class SubTaskInterpreterDetailsModule {
}
SubTaskInterpreterDetailsModule.ɵfac = function SubTaskInterpreterDetailsModule_Factory(t) { return new (t || SubTaskInterpreterDetailsModule)(); };
SubTaskInterpreterDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: SubTaskInterpreterDetailsModule });
SubTaskInterpreterDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SubTaskInterpreterDetailsModule, { declarations: [SubTaskInterpreterDetailsComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule], exports: [SubTaskInterpreterDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubTaskInterpreterDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SubTaskInterpreterDetailsComponent
                ],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                ],
                exports: [
                    SubTaskInterpreterDetailsComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of sub-task-interpreter-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SubTaskInterpreterDetailsComponent, SubTaskInterpreterDetailsModule, SubTaskInterpreterDetailsService };
//# sourceMappingURL=sub-task-interpreter-details.js.map
